// mark as client component
"use client"

import { usePathname } from "next/navigation";
import React, { Suspense } from "react"

const App = ({ children }) => {
  const path = usePathname()
  const str = path.replaceAll('/', '-')
  const slug = str.slice(0, -1)

  return(
    <div id="app" className={`w-100 page${path === '/' ? '-landing' : slug + ''}`} data-page={`page${path === '/' ? '-landing' : slug}`}>
      <Suspense>
        {children}
      </Suspense>
    </div>
  )
    
}

export default App